// `aiSkillGroupId` is the catalog-level folder FK (AISkillGroup). We
// always select it on every read and expand the parent object on
// edit/detail reads so the form can hydrate the EntitySelector picker
// without an extra request. On the paged list it stays as a scalar GUID
// — Launchpad reads it via its own query (see `entityTypes.skills`).
const aiSkillGroupExpand = {
  aiSkillGroup: { select: 'id,name,isActive' },
};

export default {
  paged: {
    select:
      'id,name,packageName,description,isActive,isManaged,published,publisher,sourceProvider,aiSkillGroupId',
    searchSelect: ['name', 'description'],
    orderBy: 'name',
  },
  item: {
    select:
      'id,name,packageName,description,compatibility,instructions,allowedTools,isActive,isManaged,scripts,references,assets,published,publisher,publishedDate,sourceProvider,aiSkillGroupId',
    expand: aiSkillGroupExpand,
  },
  itemDetail: {
    select:
      'id,name,packageName,description,compatibility,instructions,allowedTools,isActive,isManaged,scripts,references,assets,published,publisher,publishedDate,sourceProvider,providerContent,creator,modifier,created,updated,aiSkillGroupId',
    expand: aiSkillGroupExpand,
  },
};
